import { render, staticRenderFns } from "./QuoteBlock.vue?vue&type=template&id=09c97db3"
import script from "./QuoteBlock.vue?vue&type=script&lang=js"
export * from "./QuoteBlock.vue?vue&type=script&lang=js"
import style0 from "./QuoteBlock.vue?vue&type=style&index=0&id=09c97db3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports